import { render, staticRenderFns } from "./drinkCardOrder.vue?vue&type=template&id=0bf6c401&scoped=true"
import script from "./drinkCardOrder.vue?vue&type=script&lang=js"
export * from "./drinkCardOrder.vue?vue&type=script&lang=js"
import style0 from "./drinkCardOrder.vue?vue&type=style&index=0&id=0bf6c401&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf6c401",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bf6c401')) {
      api.createRecord('0bf6c401', component.options)
    } else {
      api.reload('0bf6c401', component.options)
    }
    module.hot.accept("./drinkCardOrder.vue?vue&type=template&id=0bf6c401&scoped=true", function () {
      api.rerender('0bf6c401', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basic/drinkCardOrder.vue"
export default component.exports